import {
  Box,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Fab,
  Grid,
  Modal,
  Rating,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { ModelDefinitionDto, ModelReview } from '../../models/APIModels';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import CustomInput from '../Inputs/CustomInput';
import StarIcon from '@mui/icons-material/Star';
import useAppUtils from '../../Utils/useAppUtils';
import Button from '../Button';

interface IProps {
  open: boolean;
  handleClose: () => void;
  onSave: (data) => void;
  review: ModelReview;
}

const labels: { [index: string]: string } = {
  1: 'Not Good',
  2: 'Could’ve been better',
  3: 'Ok',
  4: 'Good',
  5: 'Great',
};
const ReviewModal = ({ open, handleClose, onSave, review }: IProps) => {
  const [starRating, setStarRating] = useState<number | null>(review.starRating);
  const [hover, setHover] = useState(-1);
  const { alert, confirm } = useAppUtils();
  const formValues = useForm({
    defaultValues: useMemo(() => {
      return review;
    }, [review]),
  });

  const handleSubmit: SubmitHandler<ModelReview> = (data: ModelReview) => {
    if (!starRating) {
      alert('Please select your rating', 'error');
      return;
    }
    onSave(data);
  };

  useEffect(() => {
    setStarRating(review.starRating);
    // console.log(review);
  }, [review]);
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth={true}>
      <DialogTitle sx={{ m: 0, paddingLeft: 3 }}>Post a review</DialogTitle>
      <FormProvider {...formValues}>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box
                sx={{
                  // width: 200,
                  display: 'flex',
                  // alignItems: 'center',
                }}
              >
                <Rating
                  name="simple-controlled"
                  value={starRating}
                  onChange={(event, newValue) => {
                    formValues.setValue('starRating', newValue);
                    setStarRating(newValue);
                  }}
                  onChangeActive={(event, newHover) => {
                    setHover(newHover);
                  }}
                  emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
                 
                  // precision={0.5}
                />
                <Box sx={{ ml: 2 }}>
                  <Typography>{starRating ? labels[hover !== -1 ? hover : starRating] : 'Select your rating'}</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <CustomInput
                type="text"
                name="reviewTitle"
                value={formValues.getValues('reviewTitle') ?? ''}
                label=""
                typeValue="string"
                placeholder="Review Title"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="outlined-multiline-flexible"
                {...formValues.register('reviewText')}
                fullWidth
                multiline
                minRows={4}
                maxRows={6}
                placeholder="What did you like or dislike?"
              />
            </Grid>
          
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button  variant="contained" rounded onClick={handleClose}>
            Cancel
          </Button>
          <Button  variant="contained" rounded onClick={formValues.handleSubmit(handleSubmit)}>
            Save
          </Button>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
};

export default ReviewModal;
